import { AppStore } from "@myRedux/store";
import { schoolMergeApiClient } from "./schoolMergeApiClient";
import { ACCESSTOKENLOCALSTORAGE } from "app/localStorage";
import { updateAccessTokenWithRefreshTokenAsync } from "@myRedux/session/refreshTokenSlice";
import { wasSuccessfullyFulfilledDispatch } from "@myRedux/dispatchUtilities";
import { logout } from "@myRedux/session/sessionSlice";

const setupSchoolMergeApiClientInterceptor = (store: AppStore) => {
  schoolMergeApiClient.axiosInstance.interceptors.request.use(
    async (config) => {
      const accessToken = localStorage.getItem(ACCESSTOKENLOCALSTORAGE);
      if (accessToken) {
        config.headers['authorization'] = `Bearer ${accessToken}`;
      }
      else {
        config.headers.delete('authorization');
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  schoolMergeApiClient.axiosInstance.interceptors.response.use(
    response => response,
    error => {
      const updateAccessToken = async (retries: number) : Promise<any> => {
        const payload = await store.dispatch(updateAccessTokenWithRefreshTokenAsync());
        if (!wasSuccessfullyFulfilledDispatch(payload)) {
          retries++;
          if (retries < 3 && payload.payload !== 'UNAUTHORIZED') {
            return updateAccessToken(retries);
          }
          else {
            store.dispatch(logout());
          }
        }
        return schoolMergeApiClient.axiosInstance.request(error.config);
      };

      const status = error.response ? error.response.status : null;
      if (status === 401) {
        return updateAccessToken(0);
      }
      return Promise.reject(error);
    }
  )
}

export default setupSchoolMergeApiClientInterceptor;